<template>
  <div>
    <KlaimHadiah ref="klaimHadiah">
      <template v-slot:actions>
        <b-col cols="12" class="klaim-hadiah-action">
          <hr class="klaim-hadiah-divider" />
          <h6 class="font-600 mb-2">Klaim Hadiah Spektakuler</h6>
          <div class="d-flex flex-wrap align-items-center klaim-hadiah-buttons">
            <b-button variant="pgiBtn" @click="openKlaimHadiahSpektakulerModal">
              <i class="fa fa-search mr-2"></i>Input Kode Hadiah
            </b-button>
            <b-button variant="pgiBtn" @click="toggleKlaimHadiahSpektakulerClaimList">
              <i class="fa fa-list mr-2"></i>Lihat Daftar Klaim
            </b-button>
          </div>
        </b-col>
      </template>
      <template v-slot:extra-content>
        <KlaimHadiahSpektakuler
          ref="klaimHadiahDetail"
        />
      </template>
    </KlaimHadiah>
  </div>
</template>

<script>
import KlaimHadiah from '@/components/gadai/klaim-hadiah/KlaimHadiah'
import KlaimHadiahSpektakuler from '@/components/gadai/klaim-hadiah/KlaimHadiahSpektakuler'

export default {
  name: 'klaim-hadiah-page',
  components: {
    KlaimHadiah,
    KlaimHadiahSpektakuler,
  },
  data() {
    return {
    }
  },
  methods: {
    openKlaimHadiahSpektakulerModal() {
      this.$refs.klaimHadiahDetail.openSearchModal()
    },
    toggleKlaimHadiahSpektakulerClaimList() {
      this.$refs.klaimHadiahDetail.toggleClaimList()
    },
  },
}
</script>

<style scoped>
.klaim-hadiah-action {
  margin-top: 24px;
}

.klaim-hadiah-divider {
  margin-top: 0;
  margin-bottom: 24px;
}

.klaim-hadiah-buttons {
  gap: 8px;
}
</style>
